import { AccordionSummary } from '@eversports/react-components/primitives/Accordion'
import Flex from '@eversports/react-components/primitives/Flex'
import { usePyroField } from 'pyro-form'
import React, { useCallback } from 'react'

import useCheckoutContext from '../../data/useCheckoutContext'
import {
  Mandate,
  PaymentMethod,
  PaymentMethodVerificationMethod,
  StoredBankAccountWithMandates,
} from '../../typings/Payment'

import AdditionalPaymentMethod from './AdditionalPaymentMethod'
import PaymentMethodExpansionPanel from './PaymentMethodExpansionPanel'
import PaymentMethodExpansionPanelDetails from './PaymentMethodExpansionPanelDetails'
import PaymentMethodExpansionPanelHeader from './PaymentMethodExpansionPanelHeader'
import PaymentMethodInformation from './PaymentMethodInformation'

interface Props {
  paymentMethods: Array<PaymentMethod>
  venueMandate: Mandate | null
  verifyWith: PaymentMethodVerificationMethod | null
  storedBankAccounts: Array<StoredBankAccountWithMandates>
}

const AdditionalPaymentMethods = ({ paymentMethods, venueMandate, verifyWith, storedBankAccounts }: Props) => {
  const { core } = usePyroField('type')
  const context = useCheckoutContext()

  const handleClick = useCallback(() => {
    context.setIsPaymentValid(true)
  }, [])

  return (
    <PaymentMethodExpansionPanel>
      <AccordionSummary>
        <PaymentMethodExpansionPanelHeader paymentOption="additional-payment-methods" />
      </AccordionSummary>
      <PaymentMethodExpansionPanelDetails>
        <div>
          <Flex flexWrap="wrap">
            {paymentMethods.map((paymentMethod) => (
              <AdditionalPaymentMethod
                key={paymentMethod.type}
                paymentMethodType={paymentMethod.type}
                isSelected={core.value === paymentMethod.type}
                verifyWith={verifyWith}
                onClick={handleClick}
              />
            ))}
          </Flex>
          <PaymentMethodInformation
            selectedPaymentMethodType={core.value}
            storedBankAccounts={storedBankAccounts}
            verifyWith={verifyWith}
            venueMandate={venueMandate}
          />
        </div>
      </PaymentMethodExpansionPanelDetails>
    </PaymentMethodExpansionPanel>
  )
}

export default AdditionalPaymentMethods
